module.exports = __webpack_public_path__ + "static/media/star-orange.a8392554.svg";